import { Product } from '../../pages/leasing-store/types';
import { useUser } from '../../hooks/useUser';
import { LeasingLoginPromptModal } from './LeasingLoginPromptModal';
import { UnifiedOrderModal } from '../../pages/leasing-store/components/modals/UnifiedOrderModal';

interface LeasingRequestControllerProps {
  product: Product;
  requestType: 'leasing' | 'location' | 'achat' | 'cash';
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (formData: any) => void;
  returnToProductDetail?: boolean;
}

export function LeasingRequestController({
  product,
  requestType,
  isOpen,
  onClose,
  onSubmit,
  returnToProductDetail = false
}: LeasingRequestControllerProps) {
  const { isAuthenticated } = useUser();
  
  // Si l'utilisateur est authentifié, afficher directement le modal de commande unifié
  // Sinon, afficher le modal de connexion
  if (!isOpen) return null;
  
  if (isAuthenticated) {
    return (
      <UnifiedOrderModal
        initialProduct={product}
        isOpen={true}
        onClose={onClose}
        onSubmit={onSubmit}
        initialRequestType={requestType}
      />
    );
  } else {
    return (
      <LeasingLoginPromptModal
        isOpen={true}
        onClose={onClose}
        product={product}
        requestType={requestType}
        returnToProductDetail={returnToProductDetail}
      />
    );
  }
}
